"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addNewCard = addNewCard;
exports.createPaymentForAddCardSaga = createPaymentForAddCardSaga;
exports.deleteSavedCardV2Saga = deleteSavedCardV2Saga;
exports.getCardStatus = getCardStatus;
exports.markSavedCardAsDefaultV2Saga = markSavedCardAsDefaultV2Saga;
exports.paymentWatchers = paymentWatchers;
exports.removePaymentCard = removePaymentCard;
exports.saveNewCard = saveNewCard;
exports.saveNewCardV2 = saveNewCardV2;
exports.setDefaultCard = setDefaultCard;
var _effects = require("redux-saga/effects");
var _sagas = require("../../auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/payments"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* getPaymentCards(params) {
  try {
    yield (0, _effects.put)(actions.GET_PAYMENT_CARDS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPaymentCards, params.data.param, tokenData);
    yield (0, _effects.put)(actions.GET_PAYMENT_CARDS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PAYMENT_CARDS_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getSavedCardsV2Saga(params) {
  try {
    yield (0, _effects.put)(actions.GET_SAVED_CARDS_V2_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getSavedCardsV2, params.data.param, tokenData);
    yield (0, _effects.put)(actions.GET_SAVED_CARDS_V2_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_SAVED_CARDS_V2_API.failure(err));
    params.data.onFailure(err);
  }
}
function* setDefaultCard(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.SET_DEFAULT_CARD_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.setDefaultCard, requestParams, tokenData);
    yield (0, _effects.put)(actions.SET_DEFAULT_CARD_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.SET_DEFAULT_CARD_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* deleteSavedCardV2Saga(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.DELETE_SAVED_CARD_V2_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.deleteSavedCardV2, requestParams, tokenData);
    yield (0, _effects.put)(actions.DELETE_SAVED_CARD_V2_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.DELETE_SAVED_CARD_V2_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* markSavedCardAsDefaultV2Saga(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.MARK_SAVED_CARD_AS_DEFAULT_V2_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.markSavedCardAsDefaultV2, requestParams, tokenData);
    yield (0, _effects.put)(actions.MARK_SAVED_CARD_AS_DEFAULT_V2_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.MARK_SAVED_CARD_AS_DEFAULT_V2_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* removePaymentCard(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.REMOVE_PAYMENT_CARD_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.removePaymentCard, requestParams, tokenData);
    yield (0, _effects.put)(actions.REMOVE_PAYMENT_CARD_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.REMOVE_PAYMENT_CARD_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* addNewCard(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.ADD_NEW_CARD_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.addNewCard, requestParams, tokenData);
    yield (0, _effects.put)(actions.ADD_NEW_CARD_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.ADD_NEW_CARD_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* createPaymentForAddCardSaga(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.CREATE_PAYMENT_FOR_ADD_CARD_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.createPaymentForAddCard, requestParams, tokenData);
    yield (0, _effects.put)(actions.CREATE_PAYMENT_FOR_ADD_CARD_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CREATE_PAYMENT_FOR_ADD_CARD_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* saveNewCardV2(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.SAVE_NEW_CARD_V2_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.saveNewCardV2, requestParams, tokenData);
    yield (0, _effects.put)(actions.SAVE_NEW_CARD_V2_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.SAVE_NEW_CARD_V2_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* saveNewCard(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.SAVE_NEW_CARD_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.saveNewCard, requestParams, tokenData);
    yield (0, _effects.put)(actions.SAVE_NEW_CARD_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.SAVE_NEW_CARD_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getCardStatus(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.GET_CARD_STATUS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCardStatus, requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_CARD_STATUS_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_CARD_STATUS_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* paymentWatchers() {
  yield (0, _effects.takeLatest)(actions.GET_PAYMENT_CARDS, getPaymentCards);
  yield (0, _effects.takeLatest)(actions.SET_DEFAULT_CARD, setDefaultCard);
  yield (0, _effects.takeLatest)(actions.REMOVE_PAYMENT_CARD, removePaymentCard);
  yield (0, _effects.takeLatest)(actions.ADD_NEW_CARD, addNewCard);
  yield (0, _effects.takeLatest)(actions.CREATE_PAYMENT_FOR_ADD_CARD, createPaymentForAddCardSaga);
  yield (0, _effects.takeLatest)(actions.SAVE_NEW_CARD_V2, saveNewCardV2);
  yield (0, _effects.takeLatest)(actions.GET_SAVED_CARDS_V2, getSavedCardsV2Saga);
  yield (0, _effects.takeLatest)(actions.DELETE_SAVED_CARD_V2, deleteSavedCardV2Saga);
  yield (0, _effects.takeLatest)(actions.MARK_SAVED_CARD_AS_DEFAULT_V2, markSavedCardAsDefaultV2Saga);
  yield (0, _effects.takeLatest)(actions.SAVE_NEW_CARD, saveNewCard);
  yield (0, _effects.takeLatest)(actions.GET_CARD_STATUS, getCardStatus);
}